import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { ImproveLexicalResource } from "@modules/elearning/lead";

const ImproveYourLexicalResource = () => {
  return (
    <LayoutMain
      title="Writing Masterclass - Improving Your Lexical Resource"
      footer_with_evaluation
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/elearning/improving-your-lexical-resource`}
    >
      <ImproveLexicalResource />
    </LayoutMain>
  );
};

export default ImproveYourLexicalResource;
